import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Typography, Grid, TextField } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { genfunction } from 'helpers';
import { Autocomplete } from '@material-ui/lab';
import { DialogeBox } from 'components/DialogeBox';
import { actionShopCartRemoveSingleTourWithTourHold } from 'actions';

const { GroupSizeHeader, GroupSizeChangePopupMsg, ClearCartEventPopupButton1Text, ClearCartEventPopupButton2Text } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    box100per: {
        width: "100%"
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    GroupInfoCls: {
        padding: '16px',
        textAlign: 'justify'
    }
}));

const GroupSizeSection = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [clearCartPopUp, setClearCartPopUp] = useState(false);


    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0] : null;
    const cartEvents = useSelector(state => state.reducerShopCart.events);

    const validateChangeGroupSize = (event, value) => {

        if (props.isEditEvent && cartEvents && cartEvents.length > 0 && cartEvents.find(x => x.TourEventID == props.tourEventId)) {
            let cartTourEvent = cartEvents.find(x => x.TourEventID == props.tourEventId);

            if (value && cartTourEvent.GroupSize !== value.GroupSize)
                setClearCartPopUp(true);
            else
                props.onChange(value);
        }

        else
            props.onChange(value);
    }

    const continueButtonHandler = () => {
        setClearCartPopUp(false);
    }

    const clearButtonHandler = (value) => {

        actionShopCartRemoveSingleTourWithTourHold(dispatch, cartEvents, props.tourEventId)

        setClearCartPopUp(false);
        props.toggleIsEdit(false);
        props.onChange(null);

    }

    return (
        <div >

            <DialogeBox open={clearCartPopUp} title="Confirmation"
                message={GroupSizeChangePopupMsg}
                button1text={ClearCartEventPopupButton1Text}
                button1clickhandler={clearButtonHandler}
                button2text={ClearCartEventPopupButton2Text}
                button2clickhandler={continueButtonHandler}
            ></DialogeBox>

            <Card style={{ borderRadius: "0" }} className={classes.box100per}>
                <CardHeader className={classes.tourheaderbox}
                    title={GroupSizeHeader}
                    titleTypographyProps={{ color: "inherit" }}
                />

                <Typography variant="subtitle1" color="textSecondary" className={classes.GroupInfoCls}>
                    {ReactHtmlParser(genfunction.replaceEscapeCharacters(bkngType.GroupSizeMessage))}
                </Typography>

                <CardContent>

                    <Grid style={{ padding: "10px", width: "100%" }} container alignItems="center" item xs={12} ms={12} lg={12}>
                        <Grid item xs={1} ms={1} lg={1}></Grid>
                        <Grid item xs={10} ms={10} lg={10}>
                            {bkngType.GroupSizeOptions && bkngType.GroupSizeOptions.length > 0 ?

                                <Autocomplete
                                    id="groupSize"
                                    name="groupSize"
                                    options={bkngType.GroupSizeOptions}
                                    fullWidth={true}
                                    onChange={validateChangeGroupSize}
                                    autoHighlight
                                    getOptionLabel={(option) => {
                                        if (option.hasOwnProperty('GroupSize')) {
                                            return option.GroupSize;
                                        }
                                        return option.toString();
                                    }}
                                    value={props.groupSize}

                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} variant='outlined' label="Group Size" />}

                                ></Autocomplete>

                                : ""}
                        </Grid>
                        <Grid item xs={1} ms={1} lg={1}></Grid>
                    </Grid>


                </CardContent>
            </Card>
        </div>
    );
}

export default GroupSizeSection;


